import { ReactNode, useEffect } from 'react';

import { serviceBrand } from 'src/utils/services';

/**
 * 브라우저 탭 제목을 "화면 제목 - HyunXxx"로 맞춘다. 글자가 아닌 제목(JSX)이나 빈 제목이면 브랜드 이름만 둔다.
 * hs 화면은 `HsTopBar`·`HsViewerBar`가 이걸 불러 주므로 화면마다 따로 쓸 일이 없다.
 */
export default function useDocumentTitle(title?: ReactNode) {
  const text = typeof title === 'string' || typeof title === 'number' ? String(title).trim() : '';

  useEffect(() => {
    const brand = serviceBrand();
    document.title = text ? `${text} - ${brand}` : brand;
  }, [text]);
}
